<template>
    <dx-grid
        :url="url"
        :columns="columns"
        :title="title"
        :actions="actions"
        :onRowClicked="onRowClicked"
        navigationPath="onRowClicked"
        navigationField="onRowClicked"
        :beforeSetupGrid="beforeSetupGrid"
        ref="grid"
    ></dx-grid>
</template>

<script>
export default {
    data: () => ({
        title: "Covid-19 Test Labels",
        columns: [
            {
                field: "studentID",
                label: "Student ID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "name",
                label: "Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "hName",
                label: "H Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountID",
                label: "Account ID",
                link: "GirlsCampAccountView",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "date",
                label: "Date",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "father",
                label: "Father",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "class",
                label: "Class",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "phone",
                label: "Home Phone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "cellPhone",
                label: "Cell Phone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "byUser",
                label: "User",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
        actions: [],

        regID: "",
        url: "",
    }),
    async created() {},
    methods: {
        async beforeSetupGrid() {
            await this.loadRegID();

            this.url = "girlsCampCovidTestLabels";
        },
        async loadRegID() {
            this.regID = "GC2020";
        },
        async onRowClicked(row) {
            this.$router.push({
                name: "GirlsCampAccountView",
                params: { id: row.accountID },
            });
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
</style>
